module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message-container"
  }, [_c('Tooltip', {
    staticClass: "message-tip",
    attrs: {
      "content": _vm.value > 0 ? '有' + _vm.value + '条未读信息' : '无未读信息',
      "type": "ios-bell",
      "placement": "bottom"
    }
  }, [_c('Badge', {
    attrs: {
      "count": _vm.value,
      "dot": ""
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-bell",
      "size": "22"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b615ef8","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/iview-loader??ref--1-1!./src/components/admin-blocks/message-tip.vue
// module id = g6Jh
// module chunks = 0